module.exports = __webpack_public_path__ + "img/airdrop_bg.bc064e94.svg";